import { EventProps, UserProfile, ITrackingProvider, TrackingInitOptions } from '../../../interfaces/event-tracker'

export class GTMProvider implements ITrackingProvider {
  private readonly gtmId: string

  constructor (gtmId: string) {
    this.gtmId = gtmId
  }

  init (_options?: TrackingInitOptions): void {
    if ((window as any).dataLayer != null) return
    ;(window as any).dataLayer = []
    ;(window as any).dataLayer.push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js',
      auraview_2: true
    })
    const script = document.createElement('script')
    script.async = true
    script.src = `https://www.googletagmanager.com/gtm.js?id=${this.gtmId}&l=dataLayer`
    document.head.appendChild(script)
  }

  trackEvent ({ key, metadata }: EventProps): void {
    if ((window as any).dataLayer == null) return
    ;(window as any).dataLayer.push({
      event: 'AuraviewAction',
      eventLabel: key,
      eventValue: 1,
      eventNonInteraction: true,
      properties: metadata
    })
  }

  setUser (user: UserProfile): void {
    if ((window as any).dataLayer == null) return
    ;(window as any).dataLayer.push({ userId: user.uid, auraview_2: true })
  }
}
